import { IChangePassword } from '../containers/ChangePassword/IChangePassword';
import { ExpertDetail, LastActivity, ResetPassword } from '../containers/Login/ILogin';
import { CandidateRequestLogin } from '../types/CandidateLoginRequest';
import { ExpertRequestLogin } from '../types/ExpertLoginRequest';
import { CreateCompany } from '../types/CreateCompany';
import { post } from '../utilities';
import { API_URL_PREFIX, DEFAULT_TOKEN, ConfigTypes } from '../utilities/constants';

const login = (payload: ExpertRequestLogin | CandidateRequestLogin) => {
  return post(`${API_URL_PREFIX}/login`, payload);
};

const signup = (payload: CreateCompany) => {
  return post(`${API_URL_PREFIX}/createCompany`, payload);
};

const saveLastActivity = (payload: LastActivity) => {
  return post(`${API_URL_PREFIX}/saveLastActivities`, payload);
}

const changePassword = (payload: IChangePassword) => {
  return post(`${API_URL_PREFIX}/changePassword`, payload);
}

const getExpertDetails = (expertId: string) => {
  return post(`${API_URL_PREFIX}/getExpertDetails`, { expertId, token: DEFAULT_TOKEN });
}

const getExpertConfig = (expertId: string) => {
  return post(`${API_URL_PREFIX}/getExpertConfig`, { expertId, token: DEFAULT_TOKEN, type: ConfigTypes.SAW_ON_BOARDING_VIDEO });
}

const updateExpert = (payload: ExpertDetail) => {
  return post(`${API_URL_PREFIX}/updateExpert`, { ...payload, token: DEFAULT_TOKEN });
}

const getMarketsForLogin = () => {
  return post(`${API_URL_PREFIX}/getMarkets`, { token: DEFAULT_TOKEN });
};

export interface IGetMarketInfoRequest {
  token: string;
  market: string;
}

const getMarketInfoForLogin = (payload: IGetMarketInfoRequest) => {
  return post(`${API_URL_PREFIX}/getMarketInfo`, payload);
};

const forgotPassword = (email: string) => {
  return post(`${API_URL_PREFIX}/forgetPassword`, { email, token: DEFAULT_TOKEN });
};

const resetPassword = (payload: ResetPassword) => {
  return post(`${API_URL_PREFIX}/resetPassword`, { ...payload, token: DEFAULT_TOKEN });
};

export const authService = {
  login,
  signup,
  saveLastActivity,
  changePassword,
  getExpertDetails,
  getExpertConfig,
  updateExpert,
  getMarketsForLogin,
  getMarketInfoForLogin,
  forgotPassword,
  resetPassword
};
